import React from 'react';
// Images
import GoogleLogo from '../../assets/images/media_icons/google_brand_branding_logo_network_black_icon_48px.png';
import SocialMediaPin from '../socialMedia/SocialMediaPin';
// Constants
import { GOOGLE_BUSINESS_URL } from '../../utils/Constants';

function SocialMediaIconCta() {
  const navigateToSocialMedia = (url) => {
    window.open(url, '_blank');
  };

  const socialMediaLinks = [
    {
      serviceName: 'Google',
      icon: GoogleLogo,
      url: GOOGLE_BUSINESS_URL,
    },
  ];

  return (
    <section className='grid justify-center'>
      <div className='grid grid-flow-col w-fit gap-2 lg:gap-4'>
        {socialMediaLinks.map((social) => (
          <SocialMediaPin
            key={social.serviceName}
            serviceName={social.serviceName}
            icon={social.icon}
            func={() => navigateToSocialMedia(social.url)}
          />
        ))}
      </div>
    </section>
  );
}

export default SocialMediaIconCta;
